import { validatePresence } from 'ember-changeset-validations/validators';

export function validateCampaignLineItem(args: { campaignRequired: boolean }) {
  let validation: any = {
    lineItemId: validatePresence({ presence: true, message: "Can't be blank" }),
    amount: validatePresence({ presence: true, message: "Can't be blank" }),
  };

  if (args.campaignRequired) {
    validation.campaignId = validatePresence({
      presence: true,
      message: "Can't be blank",
    });
  }

  return validation;
}
